export default __webpack_public_path__ + "static/Jimmy Susanto-854e9e1baa5711cfcce689683c4d5de0.webp";